/**
 * Route for `lifetime-commission`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { LifetimeCommissionPage } from "../features/lifetime-commission/LifetimeCommissionPage";

export const lifetimeCommissionRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/lifetime-commission",
	component: LifetimeCommissionPage,
});

export default lifetimeCommissionRoute;
